import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  getChurnBusterDetails(contact_id) {
    return http.post('organia/churn-buster/contact-probability-values', {
      contact_id,
    });
  },
  getLatestChurnRisk(contact_id) {
    return http.post('organia/churn-buster/contact-max-data', { contact_id });
  },
  removeChurnRisk(params) {
    return http.post('organia/churn-buster/justification', params);
  },
  getEmployerChurnRisk(employer_id) {
    return http.post('organia/churn-buster/employer-max-probability', {
      employer_id,
    });
  },
};
